import { render, staticRenderFns } from "./InteractionsLast.vue?vue&type=template&id=591748d2&"
import script from "./InteractionsLast.vue?vue&type=script&lang=js&"
export * from "./InteractionsLast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports